<template>
    <div >
    <div id="referenciaDesaparecen">
        <div id="referenciaDesaparecen1">
            <b-button v-b-modal.modal-alta class="btn btn-success btn_desap" @click="clickAlta()">Alta</b-button>
            <b-button v-b-modal.modal-alta class="btn btn-success btn_desap" @click="clickModificar()">Modificar</b-button>   
            <b-button v-b-modal.modal-alta class="btn btn-success btn_desap" @click="clickEliminar()">Eliminar</b-button> 
            <b-button v-b-modal.modal-buscar class="btn btn-success btn_desap" >Buscar</b-button>
        </div>  
    </div>

    <div class="container">
        <div class="row" style="margin-top:10px; text-align:center;">
            <div v-for="item in array_fotos" class="col redondeado" style="margin-top:10px;">
                <div class="margen5" @click="seleccionarDIV(item)" v-bind:id="item.id" style="margin-top:10px; position: relative;">
                    <b-img :src="item.imagen64" fluid alt="Responsive image" style="height: 80px; width: 140px;"></b-img>
                </div>
                <div class="redondeado" v-bind:id="'descrp-'+item.id" style=" margin: auto;margin-top:10px; background:#000000; color:#FFFFFF;font-size:12px; width: 150px;">{{ item.des_12c }}</div>
            </div>
        </div>
    </div>
    <b-modal id="modal-alta" 
        header-bg-variant="success"
        size="xl"
        title="Alta">
        <div class="modal-body">
            <div class="form-group">
                <label>Descripción:</label>
                <b-form-input id="Descripción" type="text" v-model="descripcion" trim style="width:320px"></b-form-input>
            </div>
            <b-form-file
                v-model="file1"
                :state="Boolean(file1)"
                accept="application/pdf, image/x-png, image/gif, image/jpeg"
                placeholder="Elija el archivo Adjunto."
                @input="cargarImagen()" 
            ></b-form-file> <!-- @input="cargarImagen()" -->
        </div>
        <template v-slot:modal-footer="{ ok }" >
            <b-button id='Boton_Alta' :hidden="mostrarBotonAlta" variant="success" @click="altaFotos()">Guardar Solicitante</b-button>
            <b-button id='Boton_Modificar' :hidden="mostrarBotonModificar" variant="success" :disabled="bloquear_ME" @click="modificarFotos()">Guardar Solicitante</b-button>
            <b-button id='Boton_Eliminar' :hidden="mostrarBotonEliminar" variant="danger" :disabled="bloquear_ME" @click="eliminarFotos()">Eliminar Solicitante</b-button>          
            <b-button id="BotonOkAlta" variant="secondary" @click="ok()">Cancelar</b-button>
        </template>
    </b-modal>
    </div>
</template>

<style>
#referenciaDesaparecen{
  top :40px;
  position:relative;
  z-index: 1;
  margin-right: 100px;
}
#referenciaDesaparecen1{
  top :0px;
  right: 20px;
  width: 120px;
  height: 400px;
  padding: 10px;

  
  padding-top: 5px;
  background-color: rgba(255, 255, 255,0);
  position:absolute;
  opacity: 0.3;
  z-index: 2;
  -webkit-transition:2s;
  -moz-transition:2s;
  -o-transition:2s; 
}
#referenciaDesaparecen1:hover {
  cursor: default;
  opacity: 1;
}
</style>

<script>

  import { mapState, mapActions } from 'vuex';
  import { mapMutations } from 'vuex'

  export default {
    name: 'Home', 
    components: {

    },
    computed:{
        ...mapState(['host','array_fotos']),
        mostrarBotonAlta(){
          return this.titulo=='Alta de' ? false : true
        },
        mostrarBotonModificar(){
          return this.titulo=='Modificar' ? false : true
        },
        mostrarBotonEliminar(){
          return this.titulo=='Eliminar' ? false : true
        },
        bloquear_ME(){
          return this.id!=0 ? false : true
        },
    },  
    methods:{
      ...mapActions(['CargarFotos']), 
      seleccionarDIV(divss){
          //console.log(divss);
          this.array_fotos.forEach(
              elemento => document.getElementById('descrp-'+elemento.id).style.background="#000000"
          );
          document.getElementById('descrp-'+divss.id).style.background="#ed9ab2";
          this.id=divss.id;
          this.descripcion=divss.descripcion;
          this.imagen64=divss.imagen64;
          // h=divss.id;

          // for(var i=0; i<app.array_fotos.length; i++) {
          //     if (app.array_fotos[i]['id']==divss.id){
          //         h=i;
          //         reg_id=divss.id;
          //     }
          // }
      },



      altaFotos: async function (){
          document.getElementById('BotonOkAlta').click();
          try{
              let newPost={
                  opcion:'Alta',
                  descripcion:this.descripcion,
                  imagen:this.imagen64,
                  size:this.size,
                  type:this.type
                };
              const entradasBD = await fetch(this.host+'fotos.php',{
                  method:'POST',
                  body: JSON.stringify(newPost),
                  headers:{
                    "Content-Type": "application/json"
                  }
              });
              this.CargarFotos();
              this.imagen64='';
          }catch (error){
              console.log(error);
          }  
      },
      modificarFotos: async function (){
          document.getElementById('BotonOkAlta').click();
          try{
              let newPost={
                  opcion:'Modificar',
                  id:this.id,
                  descripcion:this.descripcion,
                  imagen:this.imagen64,
                  size:this.size,
                  type:this.type
                };
              const entradasBD = await fetch(this.host+'fotos.php',{
                  method:'POST',
                  body: JSON.stringify(newPost),
                  headers:{
                    "Content-Type": "application/json"
                  }
              });
              this.CargarFotos();
              this.imagen64='';
              this.id=0;
          }catch (error){
              console.log(error);
          }  
      },


      clickAlta() {
        this.titulo='Alta de';
        this.descripcion='';
      },

      clickModificar() {
        this.titulo='Modificar';
      },
      clickEliminar() {
        this.titulo='Eliminar';
        //this.valorBotonEliminar(this.cant_expedientes);
      },        

      mostrarArchivo: function (e){
        this.imagen64=e.target.result;
        var imgData = this.imagen64;
        var img = new Image();       
        img.onload = function(){
          this.ancho=img.width;
          this.alto=img.height;
        };
        img.src = this.imagen64;
      },

      cargarImagen: function (){
        console.log(this.file1);
        if (this.file1.size<800000){
          this.size=this.file1.size;
          this.type=this.file1.type;
          var fileReader=new FileReader();
          fileReader.readAsDataURL(this.file1);
          fileReader.addEventListener("load",this.mostrarArchivo,false);
        }else{
          this.file1= null;
          this.makeToast('warning');
        }
      },


    },

    data() {
      return {
          id:0,
          imagen64:'',
          file1: null,
          descripcion:'',
          titulo:'',
          ancho:0,
          alto:0,
      }
    },
    created(){
        this.CargarFotos();
    },

  }


</script>
